<template>
  <div
    class="sb-header"
    :class="{
      'sb-header--has-button': hasButton,
    }"
  >
    <div class="sb-header__text-container">
      <h1 class="sb-header__title">{{ title }}</h1>
      <slot name="subtitle">
        <p v-if="subtitleText" class="sb-header__subtitle">
          {{ subtitleText }}
        </p>
      </slot>
    </div>

    <div class="sb-header__buttons-container">
      <slot name="button">
        <component
          :is="isMobileWidth() ? SbIconButton : SbButton"
          v-if="hasButton"
          :label="buttonLabel"
          :icon="buttonIcon"
          :is-loading="isLoading"
          :variant="buttonVariant"
          :is-disabled="buttonDisabled"
          :size="isMobileWidth() ? 'small' : 'medium'"
          data-testid="header-action-button"
          @click="emit('button-click')"
        />
      </slot>
    </div>
  </div>
</template>
<script lang="ts" setup>
import SbButton from '../Button'
import SbIconButton from '../IconButton'
import { isMobileWidth } from '../../utils/isMobileWidth'
import type { IconName } from '../Icon'
import type { SharedButtonVariant } from '../shared/button/types'

export type SbHeaderProps = {
  title: string
  hasButton?: boolean
  subtitleText?: string
  isLoading?: boolean
  buttonLabel?: string
  buttonIcon?: IconName
  buttonVariant?: SharedButtonVariant
  buttonDisabled?: boolean
}

withDefaults(defineProps<SbHeaderProps>(), {
  hasButton: false,
  subtitleText: '',
  isLoading: false,
  buttonLabel: '',
  buttonIcon: 'plus',
  buttonVariant: 'primary',
  buttonDisabled: false,
})

const emit = defineEmits<{
  (e: 'button-click'): void
}>()
</script>
